import { gql } from '@apollo/client';

export const ShippingSummaryFragment = gql`
  fragment ShippingSummaryFragment on Cart {
    id
    shipping_addresses {
      selected_shipping_method {
        amount {
          currency
          value
        }
        delivery_time_from
        delivery_time_to
        shipping_type
      }
      street
    }
  }
`;
